import { Enumify } from 'enumify-ts';
class FeatureComplianceRule extends Enumify() {
    description;
    static NONE = new FeatureComplianceRule('None');
    static OPTIONAL = new FeatureComplianceRule('Optional');
    static MANDATORY = new FeatureComplianceRule('Mandatory');
    static _ = FeatureComplianceRule._closeEnum();
    static selectOptionsArray() {
        return FeatureComplianceRule.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
    constructor(description) {
        super();
        this.description = description;
    }
}
export default FeatureComplianceRule;
